export default __webpack_public_path__ + "static/media/work-center.d3346611.jpg";